/* Bikesupermarket — reveal on scroll (IntersectionObserver), stagger per sezione.
   Nessuna dipendenza. Compatibile con il theme editor di Shopify. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var root = document.documentElement;
  root.classList.add('bsm-motion');

  var ITEM_SELECTOR = '.text-block, .button, .button-custom, .button-primary, .button-secondary, .resource-list__item, .email-signup, form.email-signup';
  var STAGGER = 90;   // ms fra un elemento e il successivo
  var MAX_DELAY = 720; // ms

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      el.classList.add('is-in');
      io.unobserve(el);
      var delay = parseInt(el.style.getPropertyValue('--bsm-delay') || '0', 10);
      setTimeout(function () { el.classList.add('is-done'); }, delay + 1100);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

  function isNestedCard(el) {
    return !el.classList.contains('resource-list__item') && el.closest('.resource-list__item');
  }

  function prepareSection(section) {
    var items = section.querySelectorAll(ITEM_SELECTOR);
    var i = 0;
    var isHero = !!section.querySelector('.hero');
    Array.prototype.forEach.call(items, function (el) {
      if (el.hasAttribute('data-bsm-reveal')) return;
      if (isNestedCard(el)) return;
      // un text-block dentro un altro text-block: anima solo l'esterno
      if (el.classList.contains('text-block') && el.parentElement && el.parentElement.closest('.text-block')) return;
      el.setAttribute('data-bsm-reveal', '');
      var delay = Math.min(i * STAGGER, MAX_DELAY) + (isHero ? 250 : 0);
      el.style.setProperty('--bsm-delay', delay + 'ms');
      i++;
      io.observe(el);
    });
  }

  function init(scope) {
    scope = scope || document;
    var sections = scope.querySelectorAll('#MainContent > .shopify-section, footer .shopify-section');
    if (!sections.length && scope !== document && scope.classList && scope.classList.contains('shopify-section')) {
      sections = [scope];
    }
    Array.prototype.forEach.call(sections, prepareSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: quando una sezione viene ricaricata o riordinata
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:reorder', function () { init(); });
  document.addEventListener('shopify:section:select', function (e) {
    // mostra subito gli elementi della sezione selezionata nell'editor
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-bsm-reveal]'), function (el) {
      el.classList.add('is-in', 'is-done');
    });
  });

  // Sicurezza: se per qualsiasi motivo qualcosa resta nascosto, lo mostriamo dopo 4s
  setTimeout(function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bsm-reveal]:not(.is-in)'), function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in', 'is-done');
    });
  }, 4000);
})();
